import type { ResourceFormValues } from "@/types";

export const EMPTY_RESOURCE_FORM: ResourceFormValues = {
  name: "",
  shortName: "",
  displayName: "",
  slug: "",
  description: "",
};
